import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { memo, useState } from "react";
import BSZActions from "./BSZActions";

/**
 * =========================================================
 * ✅ BSZ SECTION CARD (like ShiftCard)
 * =========================================================
 */
function BszSectionCard({
  title,
  subtitle,
  children,
  defaultExpanded = true,
  dialogs,
  actions,
  showActions,
  showAll = false,
  setShowHistory,
  visibleProjects = [],
}) {
  const theme = useTheme();

  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      {/* ✅ HEADER */}
      <Box
        onClick={() => setExpanded((prev) => !prev)}
        sx={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 3,
        }}
      >
        {/* ✅ LEFT SIDE (column!) */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography
            sx={{
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            {title}
          </Typography>

          {showActions && title === "Arbeitsplätze" && (
            <BSZActions dialogs={dialogs} actions={actions} />
          )}
        </Box>

        {/* ✅ RIGHT SIDE */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {subtitle && (
            <Typography
              sx={{
                fontSize: "0.75rem",
                fontWeight: 600,
                opacity: 0.7,
              }}
            >
              {subtitle}
            </Typography>
          )}
          {showAll && expanded && (
            <Typography
              sx={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={(e) => {
                e.stopPropagation();
                setShowHistory(true);
              }}
            >
              Alle ({visibleProjects.length})
            </Typography>
          )}
          <Typography sx={{ opacity: 0.6 }}>{expanded ? "▾" : "▸"}</Typography>
        </Box>
      </Box>

      {/* ✅ CONTENT */}
      {expanded && <Box>{children}</Box>}
    </Box>
  );
}

export default memo(BszSectionCard);
